import userflow from "userflow.js"

export async function userflowInitialize(userId: string) {
  
  try {
    userflow.init((process.env.REACT_APP_USERFLOW_TOKEN || "") as string);
    userflow.identify(userId)
    console.log("Userflow initialized with user ID");
  } catch (error) {
    console.error("Error initializing Userflow:", error);
  }
}

export function userflowLogout() {
  userflow.reset();
  console.log("Userflow identity reset on logout.");
}